import UI from "./base/UI";

export default class Step extends UI {
    defaults = {
        activeType: 'inprogress',
        defaultNo: undefined,
    };

    constructor(el, options){
        super('step' , el);
        this.init(el, options);
    }

    init(el, options){
        this.defaults = {...this.defaults, ...options};
        this.initState();
    }

    initState(){
        if( this.defaults.defaultNo !== undefined ){
            this.state(this.defaults.defaultNo);
        }
    }

    update(){
        this.defaults.no = this.$el.attr('data-default-no')
        this.state(this.defaults.no);
    }

    render(){

    }

    attachEvents(){

    }

    close(index){

    }

    detachEvents(){

    }

    destroy(){

    }

    a11yInit(){

    }

    state( index ){
        const list = this.$el.find( ".kds-step__item" );
        list.each((idx, el) => {
            idx = idx + 1;
            el = $( el );
            
            let stateTxt = "";
            let stateClass = "";

            el.removeClass( "default completed inprogress accent" );
            
            if( idx > index ){
                stateClass = "default";
                stateTxt = "단계 미완료";
            }else if( idx < index ){
                stateClass = "completed";
                stateTxt = "단계 완료됨";
            }else{
                stateClass = this.defaults.activeType;
                stateTxt = "단계 진행중";
            }

            el.find( ".hide-txt" ).text( stateTxt );
            el.addClass( stateClass );
        });
    }

    detachEvents(){

    }
}

